var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPaperPlane = function SvgPaperPlane(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1616 5.02585C21.5748 3.68311 20.3171 2.42544 18.9744 2.83858L3.16525 7.70293C1.65628 8.16722 1.48518 10.2347 2.89728 10.9408L9.59751 14.2909C9.64589 14.3151 9.68512 14.3543 9.70931 14.4027L13.0594 21.1029C13.7655 22.515 15.833 22.3439 16.2973 20.835L21.1616 5.02585ZM19.4155 4.27225C19.6073 4.21323 19.787 4.3929 19.728 4.58472L14.8636 20.3938C14.7973 20.6094 14.5019 20.6338 14.4011 20.4321L11.1435 13.9171L15.6841 9.37652C15.977 9.08363 15.977 8.60875 15.6841 8.31586C15.3912 8.02297 14.9163 8.02297 14.6234 8.31586L10.0828 12.8565L3.5681 9.59915C3.36637 9.49828 3.39081 9.20292 3.60638 9.1366L19.4155 4.27225Z",
    fill: "currentColor"
  })));
};
export default SvgPaperPlane;